// session components
const SignUpOne = () => import('@/views/session/SignUpOne')
const LoginOne = () => import('@/views/session/LoginOne')
const PostLogin = () => import('@/views/session/PostLogin')
const LockScreen = () => import('@/views/session/LockScreen')
const ForgotPassword = () => import('@/views/session/ForgotPassword')
const ResetPassword = () => import('@/views/session/ResetPassword')

const menuUsers = [
  {
    path: '/session/sign-up',
    component: SignUpOne,
    meta: {
      title: 'message.signUp',
      breadcrumb: 'Session / Sign Up'
    }
  },
  {
    path: '/admin/login',
    component: LoginOne,
    meta: {
      title: 'message.login',
      breadcrumb: 'Admin / Login'
    }
  },
  {
    path: '/admin/pastlogin',
    component: PostLogin,
    meta: {
      title: 'message.passlogin',
      breadcrumb: 'Admin Pass Login'
    }
  },
  {
    path: '/admin/logout',
    meta: {
      title: 'message.logout'
    }
  },
  {
    path: '/session/lock-screen',
    component: LockScreen,
    meta: {
      title: 'Lock Screen',
      breadcrumb: 'Session / Lock Screen'
    }
  },
  {
    path: '/session/forgot-password',
    component: ForgotPassword,
    meta: {
      title: 'message.forgotPassword',
      breadcrumb: 'Session / Forgot Password'
    }
  },
  {
    path: '/session/reset-password',
    component: ResetPassword,
    meta: {
      title: 'message.resetPassword',
      breadcrumb: 'Session / Reset Password'
    }
  }
]

const routerUser = menuUsers.map(data => {
  const { path, title, component, children } = data

  return {
    path: path,
    name: title,
    component: component,
    meta: {
      title: title,
      requiresAuth: true,
      breadcrumb: title
    },
    children: children
  }
})

export default routerUser
